<template>
    <div class="d-flex justify-content-between text-right pt-4">
        <div>
            <b-btn v-if="register_step === 1"
                   variant="outline-secondary"
                   :disabled="register_loading"
                   class="mr-2"
                   :to="{ name: 'Login' }"
            >
                {{ $t(`돌아가기`) }}
            </b-btn>
            <b-btn v-if="register_step === 2 && !duplicated"
                   variant="secondary"
                   :disabled="register_loading"
                   class="mr-2"
                   @click="initiateAllData"
            >
                {{ $t(`뒤로가기`) }}
            </b-btn>
            <b-btn variant="warning"
                   :disabled="register_loading"
                   @click="$bvModal.show(inquiryModalId)"
            >
                {{ $t(`문의하기`) }}
            </b-btn>
        </div>

        <div class="ml-auto">
            <slot></slot>
        </div>
    </div>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import {REGISTER_INQUIRY_MODAL_ID} from '@/components/auth/Register/_SubComponents/RegisterInquiryModal.vue';

export default {
    name: 'CommonRegisterFooter',
    data() {
        return {inquiryModalId: REGISTER_INQUIRY_MODAL_ID};
    },
    computed: {
        ...mapState('register', ['register_step', 'register_loading', 'duplicated']),
    },
    methods: {
        // Step 2 에서 뒤로가기 = 업체 조회부터 다시 (고른 업체·입력 모두 비움)
        ...mapActions('register', ['initiateAllData']),
    },
};
</script>
